// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Block from "../Block";

// #####################################################

export const CardBodyItem = styled(({ ...rest }) => <Block {...rest} />)`
	display: flex;
	flex-direction: column;
	padding: 0.75rem 0rem;
	border-bottom: var(--size-grid-small) solid var(--dz-sys-divider-color);

	${({ $noPaddingTop }) =>
		$noPaddingTop &&
		css`
			padding-top: 0;
		`}
`;

// #####################################################
